import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function DividendDialog({ open, onOpenChange, holdings, onSaved, prefillHoldingId }) {
  const [holding_id, setHolding] = useState("");
  const [amount, setAmount] = useState("");
  const [payment_date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [notes, setNotes] = useState("");

  useEffect(() => {
    setHolding(prefillHoldingId || holdings?.[0]?.id || "");
  }, [prefillHoldingId, holdings, open]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/dividends", {
        holding_id,
        amount: Number(amount),
        payment_date,
        notes,
      });
      toast.success("Dividend recorded");
      onSaved?.();
      onOpenChange(false);
      setAmount(""); setNotes("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed");
    }
  };

  const inputCls = "w-full bg-champagne border border-stone px-3 py-2 text-sm font-mono text-graphite focus:border-paars focus:outline-none rounded-none";
  const labelCls = "text-[10px] tracking-[0.2em] uppercase text-graphite/55 font-bold block mb-1.5";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="!rounded-none bg-white border border-stone max-w-md text-graphite p-0">
        <DialogHeader className="px-6 py-4 border-b border-stone">
          <DialogTitle className="text-base font-mono uppercase tracking-widest text-paars-dark">
            // RECORD PAYMENT
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="p-6 space-y-4">
          <div>
            <label className={labelCls}>Holding *</label>
            <select data-testid="div-holding-select" required value={holding_id} onChange={(e)=>setHolding(e.target.value)} className={inputCls}>
              {holdings?.map((h)=> (
                <option key={h.id} value={h.id}>{h.ticker} — {h.shares} sh</option>
              ))}
            </select>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className={labelCls}>Amount ($) *</label>
              <input data-testid="div-amount-input" required type="number" step="0.01" value={amount} onChange={(e)=>setAmount(e.target.value)} className={inputCls} />
            </div>
            <div>
              <label className={labelCls}>Date *</label>
              <input required type="date" value={payment_date} onChange={(e)=>setDate(e.target.value)} className={inputCls} />
            </div>
          </div>
          <div>
            <label className={labelCls}>Notes</label>
            <input value={notes} onChange={(e)=>setNotes(e.target.value)} className={inputCls} />
          </div>
          <DialogFooter className="pt-2 !flex !justify-end gap-2">
            <button type="button" onClick={()=>onOpenChange(false)} className="px-5 py-2.5 border border-paars-dark/30 text-graphite/80 text-sm hover:bg-stone/50">Cancel</button>
            <button data-testid="save-dividend-btn" type="submit" className="px-5 py-2.5 bg-paars text-graphite font-semibold text-sm hover:bg-paars-light">RECORD</button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
